import { get, put } from 'utils/rxfetch'

import mockRedTeamAPI from './redTeam.mock'

const USE_MOCK_API = false

const realAPI = {
  getRedTeamStatus(companyId = '') {
    return get(`/members-api/red-team/company/profile/?companyFilter=${companyId}`)
  },

  getAttackGenerationData(companyId = '') {
    return get(`/members-api/red-team/company/attack-progress/?companyFilter=${companyId}`)
  },

  getCompanyRisk(companyId = '') {
    return get(`/members-api/red-team/company/risk/?companyFilter=${companyId}`)
  },

  getCompanyRiskTrend(companyId = '') {
    return get(`/members-api/red-team/company/risk-trend/?companyFilter=${companyId}`)
  },

  getTrainingActivity(companyId = '', page = 0, perPage = 10) {
    return get(
      `/members-api/red-team/company/stories/?companyFilter=${companyId}&page=${
        page + 1
      }&page_size=${perPage}`
    )
  },

  submitAttackFeedback(storyId, attackEmailId, feedback, comment = null, companyId = '') {
    return put(
      `/members-api/red-team/company/stories/${storyId}/attack-emails/${attackEmailId}/feedback/?companyFilter=${companyId}`,
      { feedback, comment }
    )
  },
}

const redTeamAPI = USE_MOCK_API ? mockRedTeamAPI : realAPI

export default redTeamAPI
export { USE_MOCK_API }
